// extracted by mini-css-extract-plugin
module.exports = {"cardImage":"ProductCard_cardImage__rrd0Z","image":"ProductCard_image__II67p","circlecolor":"ProductCard_circlecolor__btn_6"};